import { object, string } from "yup";

export const LoginSchema = object({
  userName: string().required("Задолжително"),
  password: string().required("Задолжително"),
});
